var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGisMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665:3941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.495076 12.416C0.26764 12.5474 0.101695 12.7637 0.0337341 13.0174C-0.0342266 13.2711 0.00136305 13.5414 0.132676 13.7689L4.53428 21.3932C4.59932 21.5059 4.68592 21.6046 4.78913 21.6838C4.89234 21.763 5.01013 21.821 5.13578 21.8547C5.26143 21.8883 5.39248 21.8969 5.52144 21.8799C5.6504 21.8629 5.77476 21.8207 5.8874 21.7556L23.5048 11.5844C23.6175 11.5194 23.7162 11.4328 23.7954 11.3296C23.8746 11.2264 23.9326 11.1086 23.9663 10.9829C24 10.8573 24.0085 10.7262 23.9915 10.5973C23.9745 10.4683 23.9323 10.344 23.8672 10.2313L19.4656 2.60699C19.4006 2.49435 19.314 2.39562 19.2108 2.31644C19.1076 2.23726 18.9898 2.17919 18.8641 2.14554C18.7385 2.11188 18.6074 2.10331 18.4785 2.12031C18.3495 2.1373 18.2252 2.17954 18.1125 2.24459L0.495076 12.416ZM2.34332 13.6362L18.2452 4.45523L21.6566 10.364L20.5106 11.0257L19.2321 8.81075L18.3744 9.30611L19.6528 11.5208L18.3412 12.2783L17.0625 10.0633L16.2048 10.5587L17.4835 12.7734L16.1733 13.5299L14.8946 11.3149L14.0368 11.8103L15.3156 14.025L14.004 14.7824L12.227 11.7049L11.3692 12.2L13.1462 15.2776L11.8344 16.035L10.5556 13.82L9.69788 14.3154L10.9766 16.5301L9.66644 17.2864L8.38796 15.0716L7.5302 15.567L8.80868 17.7817L7.49708 18.5389L6.21836 16.3242L5.3606 16.8196L6.63932 19.0343L5.75468 19.545L2.34332 13.6362Z",
    fill: "url(#paint0_linear_665:3941)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665:3941",
    x1: 24,
    y1: 21.8884,
    x2: 0.908993,
    y2: 11.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665:3941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGisMeasure);
export default __webpack_public_path__ + "static/media/gis_measure.349170ebcfae5186385b75d78fd3def2.svg";
export { ForwardRef as ReactComponent };